// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      maintStrategyTypeOptions: [
        "RTF",
        "PFT",
        "TBM",
        "CBM",
        "SMS"
      ],
      // eslint-disable-next-line
      maintStrategyThemeOptions: [
        "Safety",
        "Production",
        "Regulation"
      ],
      // eslint-disable-next-line
      maintStrategyLevelOptions: [
        "Company",
        "Facility",
        "System",
        "Unit",
        "Type",
        "Equip"
      ],
      // eslint-disable-next-line
      maintStrategyDriverOptions: [
        "Compliance",
        "Regulation",
        "Legal",
        "Corporate",
        "Standard",
        "External",
        "Reliability",
        "Safety",
        "Environment",
        "Factory",
        "Vendor",
        "Cost",
        "Analysis"
      ]
    };
  }
};
